module.exports = __webpack_public_path__ + "static/media/view exam details.142253ab.svg";